import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
	path: '/',
	redirect: '/PinjamCepat'
  },{ //跳转页
	  path: '/PinjamCepat',
	  name: 'PinjamCepat',
	  component: () => import('@/page/Pinjam/PinjamCepat')
  }
]

const router = new VueRouter({
  routes
})

export default router